import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigManagerComponent } from './config-manager.component';
import { ConfigManagerRoutingModule } from './config-manager-routing.module';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { ConfigListComponent } from './components/config-list/config-list.component';
import { ConfigEditorComponent } from './components/config-editor/config-editor.component';

@NgModule({
  declarations: [
    ConfigManagerComponent,
    NavBarComponent,
    ConfigListComponent,
    ConfigEditorComponent
  ],
  imports: [
    ConfigManagerRoutingModule,
    CommonModule
  ],
  providers: []
})
export class ConfigManagerModule { }
